import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 640;

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState<boolean | undefined>(true);

    useEffect(() => {
        const checkIsMobile = () => {
            const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
            setIsMobile(mql.matches);
        };

        checkIsMobile();

        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    return !!isMobile;
}
